import { render, staticRenderFns } from "./BenefitsSectionCard.vue?vue&type=template&id=3b187ae3&scoped=true"
import script from "./BenefitsSectionCard.vue?vue&type=script&lang=js"
export * from "./BenefitsSectionCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSectionCard.vue?vue&type=style&index=0&id=3b187ae3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b187ae3",
  null
  
)

export default component.exports